<template>
  <div v-if="isAvatarReady" class="user-heading round">
    <a href="#">
      <img :src="avatarUrl" alt="User Avatar" />
    </a>
    <h1>{{ userName }}</h1>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { ref, computed, watch } from "vue";

export default {
  setup() {
    const store = useStore();
    const isAvatarReady = ref(false);

    const avatarUrl = computed(() => {
      const fetchedAvatar = store.getters["profile/getAvatar"];
      return fetchedAvatar
        ? `http://localhost:9000/story/${fetchedAvatar}`
        : "/img/Friends/guy-3.jpg";
    });

    const userName = computed(() => {
      return store.getters["profile/getName"] || "John Breakgrow";
    });

    watch(
      () => store.getters["profile/getAvatar"],
      (newAvatar) => {
        isAvatarReady.value = !!newAvatar;
      },
      { immediate: true }
    );

    return {
      avatarUrl,
      userName,
      isAvatarReady,
    };
  },
};
</script>
